import { Controller } from "@hotwired/stimulus"
import Dropzone from "dropzone"
import "dropzone/dist/dropzone.css"

// Wraps a plain <input type="file"> with a Dropzone drag-and-drop zone +
// image preview. Dropzone itself never uploads anything (autoProcessQueue:
// false) — on every add/remove, the real native input's FileList is synced
// via the DataTransfer API, so the surrounding Rails form still submits
// exactly as it always did (multipart POST, same param name). No backend
// change needed.
//
// Usage: wrap the existing <input type="file" ...> in a container with
// data-controller="dropzone-upload" data-dropzone-upload-target="input".
export default class extends Controller {
  static targets = ["input"]

  connect() {
    // Dropzone auto-discovers any element with the .dropzone class unless
    // told not to — since we're driving it explicitly per instance here,
    // that global auto-discovery would double-initialize this same element.
    Dropzone.autoDiscover = false

    this.inputTarget.style.display = "none"
    this.dropzoneEl = document.createElement("div")
    this.dropzoneEl.className = "dropzone-upload-zone border border-2 border-dashed rounded p-4 text-center text-muted"
    this.dropzoneEl.innerHTML = `<i class="bi bi-cloud-arrow-up fs-2 d-block mb-1"></i>${this.element.dataset.dropzoneUploadLabelValue || "Glissez une image ici, ou cliquez pour parcourir"}`
    this.element.insertBefore(this.dropzoneEl, this.inputTarget)

    this.dz = new Dropzone(this.dropzoneEl, {
      url: "/", // never actually used — autoProcessQueue stays false
      autoProcessQueue: false,
      acceptedFiles: "image/*",
      maxFiles: 1,
      addRemoveLinks: true,
      dictRemoveFile: "Retirer",
      previewsContainer: this.dropzoneEl,
      thumbnailWidth: 120,
      thumbnailHeight: 120
    })

    this.dz.on("addedfile", (file) => {
      // Single-file inputs: replace any previously selected file instead of
      // accumulating (matches the plain <input> behavior it's replacing).
      if (this.dz.files.length > 1) this.dz.removeFile(this.dz.files[0])
      this._syncNativeInput(file)
    })
    this.dz.on("removedfile", () => this._syncNativeInput(null))
  }

  disconnect() {
    this.dz?.destroy()
  }

  _syncNativeInput(file) {
    const dataTransfer = new DataTransfer()
    if (file) dataTransfer.items.add(file)
    this.inputTarget.files = dataTransfer.files
  }
}
